import { Component, Vue, Prop, toNative } from "vue-facing-decorator";
import Help from "./help";

@Component
class Helpful extends Vue {
  @Prop(Object) readonly help?: Help;
}

export default toNative(Helpful);
